
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../../hook/usetoast";
import DataService from '../../../../config/DataServices'
import { queryClient } from "../../../../config";

const { postRequest, getRequest } = DataService()



export const useCreateTicket= () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/ticket/create-support", data )
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            toast.success(success?.message)
            queryClient.refetchQueries("single-ticket")

        }
    })
}

export const useGetSingleTicket = ({ticketId}) => {

    return useQuery({
        queryKey: ['single-ticket',ticketId],
        queryFn: () => {
            return getRequest(`user/ticket/single-ticket?ticketId=${ticketId}`)
        },
    })
}


export const useGetTicketHistory = ({ page, size, search, type }) => {

    return useQuery({
        queryKey: ['ticket-history',{ page, size, search, type }],
        queryFn: () => {
            return getRequest(`user/ticket/ticket-history?page=${page}&size=${size}&search=${search}&status=${type}`)
        },
    })
}